
let styles = {
    dialog: {
        display: 'flex',
        flexDirection: 'column',
        color:'black'
    },
    text: {
        marginBotton: '10px'
    },
    main_header: {
        padding: '1%',
        marginBottom: '3%',
        backgroundColor: '#32B6A7',
    },

  }
  export default styles
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/callStatus/style.js